import { jsx as t } from "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as p } from "../../../context/theme/hooks.js";
import "../../layout/Stack/Stack.js";
import d from "../../layout/Box/Box.js";
import "react";
import "../../../index-CZ8zjHGv.js";
import l from "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import s from "../../typography/Text/Text.js";
import "../../../context/Text.js";
import "../../../context/Typography.js";
import "../../../hooks/link/index.js";
function z({
  selectedValue: e,
  onChange: n,
  value: r,
  label: m
}) {
  const i = p(), o = e === r;
  return /* @__PURE__ */ t(
    d,
    {
      component: "button",
      onClick: () => n(r),
      width: "100%",
      height: "32px",
      backgroundColor: o ? i.foreground : "transparent",
      borderRadius: "small",
      border: "none",
      outline: "none",
      minWidth: "100px",
      paddingX: "xlarge",
      cursor: o ? "auto" : "pointer",
      focusVisibleStyles: {
        outline: `2px solid ${i["primary-medium-content"]}`
      },
      type: "button",
      children: /* @__PURE__ */ t(l, { children: /* @__PURE__ */ t(
        s,
        {
          size: "small",
          tone: o ? "primary" : "neutral",
          emphasis: o ? "high" : "medium",
          children: m
        }
      ) })
    }
  );
}
export {
  z as default
};
